import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { selectMultiRegisterIssueBoardIdsFromUrl } from "./multiRegisterIssuesSelectors";
import { setMultiRegisterIssueBoardIdsFromUrlInRedux } from "./multiRegisterIssuesSlice";

const parseIssueBoardIds = (search: string): string[] => {
  return new URLSearchParams(search).get("issueboardIds")?.split(",").filter(Boolean) ?? [];
};

const sameStringArray = (a: string[], b: string[]) =>
  a.length === b.length && a.every((value, index) => value === b[index]);

export const useMultiRegisterIssuesUrlSync = () => {
  const { search } = useLocation();
  const dispatch = useAppDispatch();
  const issueBoardIdsFromRedux = useAppSelector(selectMultiRegisterIssueBoardIdsFromUrl);

  useEffect(() => {
    const issueBoardIdsFromUrl = parseIssueBoardIds(search);
    if (!sameStringArray(issueBoardIdsFromUrl, issueBoardIdsFromRedux)) {
      dispatch(setMultiRegisterIssueBoardIdsFromUrlInRedux(issueBoardIdsFromUrl));
    }
  }, [dispatch, issueBoardIdsFromRedux, search]);
};
